<n-slide-window [visible]="windowVisible" [width]="SWITCH.IS_SIMPLE_MODE ? '6.08rem' : '7rem'" (onHide)="close()">
    <!-- 标题 -->
    <n-header>
        <h1 nTextTips>{{i18n.createGroupTitle}}</h1>
        <n-help-link key="authenticationusergroupCreate" *ngIf = "!SWITCH.IS_SIMPLE_MODE"></n-help-link>
        <n-help-link key="simplifyunixgroupCreate" *ngIf="SWITCH.IS_SIMPLE_MODE"></n-help-link>
    </n-header>
    <!-- 表单区域 -->
    <form [errorMessage]="errorMessage" [formGroup]="vm" [simpleMode]="SWITCH.IS_SIMPLE_MODE"
        [ngClass]="{ 'form-width-simple': SWITCH.IS_SIMPLE_MODE, 'common-form': !SWITCH.IS_SIMPLE_MODE }">
        <!-- 组名 -->
        <n-form-item [label]="i18n.name" [required]="true">
            <input type="text"
                id="create_local-auth-unix-group-name"
                nInput
                formControlName="name"
                [placeholder]="errorMessage.name.rangeByteLength">
        </n-form-item>
        <!-- 所属租户 -->
        <n-form-item [label]="i18n.vStoreLab" *ngIf="!SWITCH.IS_SIMPLE_MODE"
            [required]="!vstore || !vstore.value">
            <n-select #vstoreSelect
                id="vstore_dropdown"
                formControlName="vstoreItem"
                [rest]="vstoreRest"
                [filter]="true"
                [labelField]="'NAME'"
                [valueField]="'ID'"
                style="width: 3rem"
                (onChange)="selectedVstore = $event.option"
                *ngIf="!vstore || !vstore.value">
            </n-select>
            <div class="n-form-item-text" *ngIf="vstore && vstore.value">{{vstore.label}}</div>
        </n-form-item>
        <!-- ID -->
        <n-form-item [label]="i18n.id" [helpContent]="i18n.helpIcon.idForUserGroup">
            <div class="interval-10">
                <n-spinner id="create_local-auth-unix-group-id" [onlyInput]="true" [required]="false" [min]="idRange.min" [max]="idRange.max"
                    formControlName="id">
                </n-spinner>
                <span>{{ i18n.idRange(idRange.min, idRange.max) }}</span>
            </div>
        </n-form-item>
        <!-- 描述 -->
        <n-form-item [label]="i18n.description">
            <textarea id="create_local-auth-unix-group-description"
                nTextarea
                formControlName="description"
                [placeholder]="errorMessage.description.rangeByteLength">
            </textarea>
        </n-form-item>
    </form>
    <!-- 按钮区域 -->
    <n-footer>
        <button id="create-local-unix-group-ok-btn" nButton theme="primary" [label]="i18n.ok" (click)="onOk()"></button>
        <button id="create-local-unix-group-cancel-btn" nButton [label]="i18n.cancel" (click)="hide()"></button>
    </n-footer>
</n-slide-window>
